export var LEFT = 37;
export var RIGHT = 39;
export var UP = 38;
export var DOWN = 40;
export var KEY_0 = 48;
export var KEY_1 = 49;
export var KEY_2 = 50;
export var KEY_3 = 51;
export var KEY_4 = 52;
export var KEY_5 = 53;
export var KEY_6 = 54;
export var HEADING_KEYS = [KEY_0, KEY_1, KEY_2, KEY_3, KEY_4, KEY_5, KEY_6];
//# sourceMappingURL=consts.js.map